import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faComments,
  faVideo,
  faPhoneAlt,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';

library.add(faVideo, faComments, faPhoneAlt, faPhone);
